var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerPrefernceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_760",
    "data-name": "Group 760",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.722,
    height: 86.666,
    viewBox: "0 0 86.722 86.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M-54.757,261.2a25.613,25.613,0,0,1,3.47,1.738,6.1,6.1,0,0,1,2.661,5.074c.068,6.059.025,12.119.024,18.179a2.166,2.166,0,0,1-.051.3H-75.166v-.962c0-4.545.013-9.09-.023-13.634a1.789,1.789,0,0,0-.515-1.175q-7.107-6.537-14.273-13.009a1.626,1.626,0,0,1-.588-1.351c.025-3.14.012-6.28.012-9.625,1.011.783,1.894,1.459,2.769,2.146,5.036,3.958,10.082,7.9,15.091,11.9a2.831,2.831,0,0,0,2.426.533,9.985,9.985,0,0,1-2.992-4.886c-.834-4.218-1.19-8.448,1.2-12.348A11.267,11.267,0,0,1-59.3,239.418,10.9,10.9,0,0,1-51.4,249.953a45.5,45.5,0,0,1-.229,5.486C-51.886,257.442-52.726,258.743-54.757,261.2ZM-70.95,251.59h-.026c0,.553,0,1.106,0,1.659a8.108,8.108,0,0,0,6.18,7.889c4.658,1.175,9.316-1.369,10.3-5.9a30.961,30.961,0,0,0,.245-6.158c0-.209-.4-.561-.653-.609a11.448,11.448,0,0,1-4.69-1.982,1.222,1.222,0,0,0-1.271-.191,40.942,40.942,0,0,1-9.4,2.131.643.643,0,0,0-.679.714C-70.961,249.961-70.95,250.776-70.95,251.59Z",
    transform: "translate(135.31 -199.831)",
    fill: "#d10a11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M-346.5,286.61V276.591q0-3.889,0-7.779a6.923,6.923,0,0,1,5.933-7.178,3.093,3.093,0,0,0,.383-.135c-.426-.5-.832-.942-1.2-1.413a10.279,10.279,0,0,1-2.3-6.622,31.625,31.625,0,0,1,.368-6.073,10.832,10.832,0,0,1,10.461-8.289,10.918,10.918,0,0,1,11.232,8.555,20.293,20.293,0,0,1-.121,8.663,10.491,10.491,0,0,1-3.09,5.09,2.739,2.739,0,0,0,2.514-.573c5.72-4.547,11.477-9.047,17.224-13.561.129-.1.27-.189.508-.354.019.354.043.6.043.845,0,2.914-.014,5.827.016,8.74a1.626,1.626,0,0,1-.606,1.344c-4.729,4.282-9.434,8.588-14.169,12.862a1.8,1.8,0,0,0-.636,1.506c.023,4.457.012,8.915.012,13.372v1.018Zm5.93-39.077a20.461,20.461,0,0,0-.165,7.3A7.993,7.993,0,0,0-333,261.5c4.386.095,7.957-2.368,8.626-6.308a38.86,38.86,0,0,0,.13-6.425,5.784,5.784,0,0,0-.27-1.235Z",
    transform: "translate(346.498 -199.951)",
    fill: "#d10a11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M-164.491,38.971c-4.306-2.883-8.3-6.019-11.336-10.21a11.95,11.95,0,0,1-2.634-6.8c-.1-5.112,4.174-7.227,7.936-6.679a7.881,7.881,0,0,1,6.016,4.129c.28-.4.51-.758.76-1.1,2.7-3.658,8.579-4.225,11.545-1.056,1.981,2.117,2.049,4.651,1.249,7.272a18.035,18.035,0,0,1-4.341,6.874A47.938,47.938,0,0,1-164.491,38.971Z",
    transform: "translate(207.841 -15.188)",
    fill: "#d10a11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M-159.335,226.3l1.839-1.686,4.835,4.82-1.848,1.694Z",
    transform: "translate(192.058 -188)",
    fill: "#d10a11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M-73.688,230.683l-1.738-1.822,4.825-4.828,1.666,1.886Z",
    transform: "translate(122.819 -187.519)",
    fill: "#d10a11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M-106.2,207.356h2.74v6.907h-2.74Z",
    transform: "translate(148.214 -173.758)",
    fill: "#d10a11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M38.9,303.264a1.393,1.393,0,1,1-1.383,1.379A1.407,1.407,0,0,1,38.9,303.264Z",
    transform: "translate(29.62 -252.898)",
    fill: "#d10a11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M88.3,304.66a1.393,1.393,0,1,1-1.365-1.4A1.414,1.414,0,0,1,88.3,304.66Z",
    transform: "translate(-9.983 -252.896)",
    fill: "#d10a11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M-297.108,303.262a1.41,1.41,0,0,1,1.414,1.35,1.417,1.417,0,0,1-1.328,1.436,1.41,1.41,0,0,1-1.457-1.394A1.405,1.405,0,0,1-297.108,303.262Z",
    transform: "translate(306.874 -252.897)",
    fill: "#d10a11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M-249.065,306.042a1.412,1.412,0,0,1-1.418-1.346,1.411,1.411,0,0,1,1.322-1.44,1.409,1.409,0,0,1,1.463,1.387A1.415,1.415,0,0,1-249.065,306.042Z",
    transform: "translate(267.271 -252.89)",
    fill: "#d10a11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerPrefernceIcon);
export default __webpack_public_path__ + "static/media/PartnerPrefernceIcon.526a36c7dd07f9272c3acfca7c7ca910.svg";
export { ForwardRef as ReactComponent };